import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, Router, UrlTree } from '@angular/router';
import { Observable, map } from 'rxjs';
import { AuthService } from '../services/auth.service';

@Injectable({ providedIn: 'root' })
export class PermissionGuard implements CanActivate {
  constructor(private auth: AuthService, private router: Router) {}

  /**
   * A route states its requirement as `permission` (one) or `permissionAny`
   * (any-of, for a section whose permission was renamed and both spellings are
   * still in the wild). Either way the route is where the requirement lives —
   * the Dashboard reads the same field to decide whether to offer the card, so
   * a page and its entry point cannot disagree.
   */
  canActivate(route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> | boolean | UrlTree {
    const required: string | undefined = route.data['permission'];
    const anyOf: string[] | undefined = route.data['permissionAny'];
    return this.auth.loadPermissions().pipe(
      map(() => {
        const ok =
          (!required && !anyOf) ||
          (!!required && this.auth.hasPermission(required)) ||
          (!!anyOf && anyOf.some(p => this.auth.hasPermission(p)));
        return ok ? true : this.router.createUrlTree(['/']);
      })
    );
  }
}
